import { Component, OnInit, OnDestroy } from '@angular/core';
import { BackendService } from 'src/app/services/backend.service';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from 'src/app/shared/format-datepicker';

@Component({
    selector: 'app-blank-page',
    templateUrl: './blank-page.component.html',
    styleUrls: ['./blank-page.component.scss'],
    providers: [
        {provide: DateAdapter, useClass: AppDateAdapter},
        {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
      ]
})
export class BlankPageComponent implements OnInit, OnDestroy {
    error = false;
    showEdit: Boolean = false;
    showDelete: Boolean = false;
    errorMessage: String = '';
    dataLoading = false;
    private querySubscription;
    savedChanges = false;
    id;
    users;
    instituciones;
    admin;
    user;
    hasError = false;
    public pushRightClass: string;
    instituciones_selected: Array<any>;
    disableSubmit = 0;
    showInstitutionsSelection = false;
    institutionsEdited = false;

    constructor(private translate: TranslateService, private backendService: BackendService, private router: Router) {
        this.translate.addLangs(['es', 'pt']);

        this.router.events.subscribe(val => {
            if (
                val instanceof NavigationEnd &&
                window.innerWidth <= 992 &&
                this.isToggled()
            ) {
                this.toggleSidebar();
            }
        });
    }
    ngOnInit() {
        if (localStorage.length <= 0) {
            this.router.navigate(['../login']);
        } else {
            if (localStorage.getItem('token') != null && localStorage.getItem('token') !== '') {
                this.isAdmin();
                this.getUser();
                this.pushRightClass = 'push-right';
                this.getInstitution();
            } else {
                this.router.navigate(['../login']);
            }
        }
    }


    isToggled(): boolean {
        const dom: Element = document.querySelector('body');
        return dom.classList.contains(this.pushRightClass);
    }

    changeLang(language: string) {
        this.translate.use(language);
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle(this.pushRightClass);
    }


    getInstitution() {
        this.dataLoading = true;

        this.querySubscription = this.backendService.getInstitution().subscribe((res) => {
            if (res['errorCode'] > 0) {
                this.error = false;
                this.errorMessage = '';
                this.dataLoading = false;
                this.instituciones = res['data'];
                console.log(this.instituciones);
            } else {
                this.error = true;
                this.errorMessage = res['errorMessage'];
                this.dataLoading = false;
            }
        },
            (error) => {
                this.error = true;
                this.errorMessage = error.message;
                this.dataLoading = false;
            },
            () => {
                this.dataLoading = false;
            });
        }

    getUser() {
        this.dataLoading = true;

        this.querySubscription = this.backendService.getInstitutionalUser().subscribe((res) => {
            console.log(res);
            if (res['errorCode'] > 0) {
                this.error = false;
                this.errorMessage = '';
                this.dataLoading = false;
                res['data'].sort((a, b) => (a.name.localeCompare(b.name) || a.ape.localeCompare(b.ape)));
                console.log(res['data']);
                this.users = res['data'];
            } else {
                this.error = true;
                this.errorMessage = res['errorMessage'];
                this.dataLoading = false;
            }
        },
            (error) => {
                if (error.status === 401 || error.status === 403) {
                    localStorage.setItem('token', '');
                    this.router.navigate(['/login']);
                }
                this.error = true;
                this.errorMessage = error.message;
                this.dataLoading = false;
            },
            () => {
                this.dataLoading = false;
            });
        }

    onEdit(user) {
        this.showDelete = false;
        this.showEdit = true;
        this.user = user;
        if (this.user.entity != null) {
            this.instituciones_selected = this.user.entity.split(',');
        } else {
            this.instituciones_selected = [];
        }
        this.disableSubmit = 0;
        this.showInstitutionsSelection = false;
        this.institutionsEdited = false;
    }

    isAdmin() {
        this.admin = localStorage.getItem('admin');
        if (this.admin === 1) {
            this.router.navigate(['/layout/dashboard']);
        }
    }
    updateUser(formData) {
        this.hasError = false;
        this.dataLoading = true;
        console.log(formData.data);
        if (formData.data instanceof Date) {
            formData.data = this.formatDatePicker(formData.data);
        }
        formData.inputPlace = this.user.entity;
        this.querySubscription = this.backendService.updateUser(formData).subscribe((res) => {
          if (res['errorCode'] > 0) {
              this.error = false;
              this.errorMessage = '';
              this.dataLoading = false;
              this.savedChanges = true;
              window.location.href = window.location.href;
          } else {
              this.error = true;
              this.errorMessage = res['errorMessage'];
              this.dataLoading = false;
          }
      },
          (error) => {
            if (error.status === 401 || error.status === 403) {
                localStorage.setItem('token', '');
                this.router.navigate(['/login']);
            }
              this.error = true;
              this.errorMessage = error.message;
              this.dataLoading = false;
          },
          () => {
              this.dataLoading = false;
          });
    }

    deleteRole(user) {
        this.dataLoading = true;
        const continueDeleting = this.checkRoles(user);
        if (continueDeleting === true) {
            this.querySubscription = this.backendService.deleteRole(user.id, 'institutional_user').subscribe((res) => {
                if (res['errorCode'] > 0) {
                    this.error = false;
                    this.errorMessage = '';
                    this.dataLoading = false;
                    this.savedChanges = true;
                    window.location.href = window.location.href;
                } else {
                    this.error = true;
                    this.errorMessage = res['errorMessage'];
                    this.dataLoading = false;
                }
            },
                (error) => {
                  if (error.status === 401 || error.status === 403) {
                      localStorage.setItem('token', '');
                      this.router.navigate(['/login']);
                  }
                    this.error = true;
                    this.errorMessage = error.message;
                    this.dataLoading = false;
                },
                () => {
                    this.dataLoading = false;
                });
        }
    }

    checkRoles(user) {
        // tslint:disable-next-line:triple-equals
        if (user.rol == 1 && user.researcher == 0 && user.collaborator == 0) {
            const r = confirm(this.translate.instant('ultimoRol'));
            if (r === true) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    reloadRoute() {
        window.location.href = window.location.href;

    }

    offEdit() {
        this.showEdit = false;
    }
    onDelete(id) {
        this.showEdit = false;
        this.showDelete = true;
        this.user = id;
    }
    offDelete() {
        this.showDelete = false;
        this.disableSubmit = 0;
    }


    ngOnDestroy() {
        if (this.querySubscription) {
            this.querySubscription.unsubscribe();
        }
    }

    formatDatePicker(date: Date) {
        let day: string = date.getDate().toString();
        day = +day < 10 ? '0' + day : day;
        let month: string = (date.getMonth() + 1).toString();
        month = +month < 10 ? '0' + month : month;
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }

    changeInstitutionsSelected(event): void {
        this.user.entity = event.selected_institutions.join(',');
        this.disableSubmit--;
        this.showInstitutionsSelection = false;
        this.institutionsEdited = true;

    }

    onEditInstitutions() {
        this.disableSubmit++;
        this.showInstitutionsSelection = true;
    }

    getInstitutionName(id_institution) {
        let name_institution = '';
        this.instituciones.forEach(element => {
            if (element.number === Number(id_institution)) {
                name_institution = element.name;
            }
        });
        return name_institution;
    }
}
